import React from "react";
import { Zap } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * Compact XP/Level indicator for the navbar.
 * Shows Level pill + a small progress bar with "X / Y to next".
 */
export default function XPNavIndicator() {
  const { user } = useAuth() || {};
  if (!user) return null;
  const prog = user.level_progress || {};
  const pct = Math.max(0, Math.min(100, prog.progress_pct || 0));
  const remaining = Math.max(0, (prog.xp_next_level || 0) - (prog.xp_into_level || 0));
  return (
    <div
      data-testid="nav-xp"
      title={`Level ${user.level} — ${remaining} XP to next`}
      className="hidden md:flex items-center gap-2 pl-3 pr-3 h-10 rounded-full bg-white/5 border border-white/10"
    >
      <span className="inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-[0.18em] text-[#E50914]">
        <Zap className="w-3 h-3" /> Lv {user.level || 1}
      </span>
      <div className="w-16 h-1.5 bg-white/5 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-[#E50914] to-[#FF9F0A] transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-[10px] font-bold text-zinc-400 whitespace-nowrap">
        {remaining} XP
      </span>
    </div>
  );
}
